<template>
    <div class="children-intake-form">
        <div class="row mb-3 py-2 toolbar-bg">
            <div class="col mb-1 mb-md-0">
                <div class="btn-group btn-group-toggle" role="group">
                  <template v-if="isAuthorized('personal-data', 'form', 'edit')">
                    <input
                        class="btn-check"
                        type="radio"
                        name="forms"
                        id="new"
                        autocomplete="off"
                        :checked="status === 'new'"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="new"
                        v-on:click="status = 'new'; form = null;"
                    >Nieuw</label>
                  </template>

                    <input
                        class="btn-check"
                        type="radio"
                        name="forms"
                        id="open"
                        autocomplete="off"
                        :checked="status === 'open'"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="open"
                        v-on:click="status = 'open'; form = null;"
                    >Openstaand</label>

                    <input
                        class="btn-check"
                        type="radio"
                        name="forms"
                        id="done"
                        autocomplete="off"
                        :checked="status === 'done'"
                    >
                    <label
                        class="btn btn-outline-secondary"
                        for="done"
                        v-on:click="status = 'done'; form = null;"
                    >Definitief</label>
                </div>
            </div>
        </div>
        <div v-if="isLoading">
            <p>Laden...</p>
        </div>
        <div v-else-if="isLoading === false && form === null">
            <!-- select form / template -->
            <div v-if="status === 'new'">
                <h5>Kies een nieuw formulier</h5>
                <ul v-if="formTemplates && formTemplates.length > 0" class="list-group">
                    <li
                        v-for="template in formTemplates"
                        :key="template.id"
                        v-on:click="editForm(template)"
                        class="list-group-item"
                    >
                        {{ template.title }}
                    </li>
                </ul>
                <p v-else>Geen sjablonen gevonden</p>
            </div>
            <div v-if="status === 'open'">
                <h5>Openstaande formulieren</h5>

                <table class="table" v-if="filledInForms.open.length > 0 ">
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th>Gestart door</th>
                            <th>Gestart op</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="filledInForm in filledInForms.open"
                            :key="filledInForm.id"
                            v-on:click="editForm(filledInForm, true)"
                        >
                            <td>{{ filledInForm.title }}</td>
                            <td>{{ filledInForm.createdBy }}</td>
                            <td>{{ this.$moment(filledInForm.createdAt).format('dddd D MMMM YYYY' ) }}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="alert alert-info" v-else>Geen ingevulde formulieren</div>
            </div>
            <div v-if="status === 'done'">
                <h5>Definitieve formulieren</h5>
                <table class="table" v-if="filledInForms.done.length > 0 ">
                    <thead>
                        <tr>
                            <th>Naam</th>
                            <th v-if="isAuthorized('personal-data', 'form', 'share')" style="width: 200px;">Delen met verzorgers</th>
                            <th style="text-align: right; width: 50px;"> </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="filledInForm in filledInForms.done"
                            :key="filledInForm.id"
                        >
                            <td v-on:click="viewForm(filledInForm)">
                                {{ filledInForm.title }}
                                {{ this.$moment(filledInForm.updatedAt).format('dddd D MMMM YYYY' ) }}
                                om
                                {{ this.$moment(filledInForm.updatedAt).format('HH:mm:ss' ) }}
                            </td>
                            <td v-if="isAuthorized('personal-data', 'form', 'share')">
                                <input
                                    type="checkbox"
                                    name="delen"
                                    value="delen"
                                    :checked="filledInForm.shared"
                                    v-on:input="shareForm($event, filledInForm.id)"/> Delen met verzorgers
                            </td>
                            <td style="text-align: right;">
                                 <span
                                     style="margin-top: 5px;"
                                     v-on:click="downloadForm(filledInForm.id, filledInForm.title)"
                                     title="Download het formulier"
                                 >
                                    <icon name="file-pdf"></icon>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="alert alert-info" v-else>Geen ingevulde formulieren</div>
            </div>
        </div>
        <div v-else>
            <div
                v-for="(content, contentIndex) in form.questions[0]"
                :key="contentIndex"
            >
                <div class="row mt-2 mb-2">
                    <div
                        v-if="content.type === 'header'"
                        class="col-12"
                    >
                        <p
                            v-if="content.boldText === 1"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;' +
                        'font-weight: bold;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-else
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-if="content.infoText"
                            class="alert alert-info"
                            :style="'margin-left:' + content.marginLeft + 'px !important;'"
                        >
                            {{ content.infoText }}
                        </p>
                        <p
                            v-if="content.alert"
                            class="alert alert-danger"
                            :style="'margin-left:' + content.marginLeft + 'px !important;'"
                        >
                            {{ content.alert }}
                        </p>
                    </div>
                    <div
                        v-if="content.type === 'subheader'"
                        class="col-12"
                    >
                        <p
                            class="alert alert-secondary"
                            v-if="content.boldText === 1"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;' +
                        'font-weight: bold;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            class="alert alert-secondary"
                            v-else
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-if="content.infoText"
                            class="alert alert-info"
                            :style="'margin-left:' + content.marginLeft + 'px !important;'"
                        >
                            {{ content.infoText }}
                        </p>
                        <p
                            v-if="content.alert"
                            class="alert alert-danger"
                            :style="'margin-left:' + content.marginLeft + 'px !important;'"
                        >
                            {{ content.alert }}
                        </p>
                    </div>
                    <div
                        v-if="content.type === 'note'"
                        class="col-12"
                    >
                        <p
                            v-if="content.boldText === 1"
                            class="alert alert-info ms-5"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;' +
                        'font-weight: bold;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-else
                            class="alert alert-info ms-5"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                    </div>
                    <div
                        v-if="content.type === 'description'"
                        class="col-12"
                    >
                        <p
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                    </div>
                    <div
                        v-if="content.type === 'question'"
                        class="col-12"
                    >
                        <p
                            class="alert alert-secondary"
                            v-if="content.boldText === 1"
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;' +
                        'font-weight: bold;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            class="alert alert-secondary"
                            v-else
                            :style="
                        'margin-left:' + content.marginLeft + 'px !important;' +
                        'color:' + content.color + ';' +
                        'font-size:' + content.fontSize + 'px;'"
                        >
                            {{ content.text }}
                        </p>
                        <p
                            v-if="content.infoText"
                            class="alert alert-info"
                            :style="'margin-left:' + content.marginLeft + 'px !important;font-size: 12px;'"
                        >
                            {{ content.infoText }}
                        </p>
                        <p
                            v-if="content.alert"
                            class="alert alert-danger"
                            :style="'margin-left:' + content.marginLeft + 'px !important;font-size: 12px;'"
                        >
                            {{ content.alert }}
                        </p>
                    </div>
                </div>
                <div
                    v-if="content.type === 'question' && content['answer'] !== null"
                    class="row">
                    <div
                        class="col-12"
                    >
                        <div
                            v-if="content['answer'].type === 'radio'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'">
                            <div
                                v-for="(answer, idx) in content['answer'].options"
                                :key="idx"
                            >
                                <div v-if="idx !== 'empty' && editMode === true">
                                    <input
                                        v-if="content['answer'].value === answer.id"
                                        :type="content['answer'].type"
                                        :name="content['answer'].type + '-' + contentIndex"
                                        :value="answer.id"
                                        v-model="form['questions'][0][contentIndex]['answer']['value']"
                                        checked
                                    />
                                    <input
                                        v-else
                                        :type="content['answer'].type"
                                        :name="content['answer'].type + '-' + contentIndex"
                                        :value="answer.id"
                                        v-model="form['questions'][0][contentIndex]['answer']['value']"
                                    />
                                    <span
                                        class="ms-2"
                                        :style="'color:' + answer.color + ';'"
                                    >
                                   {{ answer.name }}
                               </span>
                                    <textarea-plus
                                        v-if="answer.note === 'on'"
                                        placeholder="Typ hier de toelichting"
                                        :value="form['questions'][0][contentIndex]['answer']['options'][idx]['noteText']"
                                        @onChange="form['questions'][0][contentIndex]['answer']['options'][idx]['noteText'] = $event"
                                    ></textarea-plus>
                                </div>
                                <div v-else>
                                    <div v-if="content['answer'].value === answer.id">
                                        {{ answer.name }} <br>
                                        <div v-if="answer.noteText">
                                            Toelichting: {{ answer.noteText }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="content['answer'].type === 'select'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'">
                            <div v-if="editMode === true">
                                <select
                                    class="form-select  form-select-sm w-100"
                                    :name="content['answer'].type + '-' + contentIndex"
                                    v-model="form['questions'][0][contentIndex]['answer']['value']"
                                >
                                    <option
                                        v-for="(answer, idx) in content['answer'].options"
                                        :key="idx"
                                        :selected="content['answer'].value === answer.id ? 'selected' : ''"
                                        :value="answer.id"
                                    >
                                        {{ answer.name }}
                                    </option>
                                </select>
                            </div>
                            <div v-else>
                                <div v-for="(answer, idx) in content['answer'].options"
                                     :key="idx"
                                >
                                    <div v-if="content['answer'].value === answer.id">
                                        {{ answer.name }} <br>
                                        <div v-if="answer.noteText">
                                            Toelichting: {{ answer.noteText }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="content['answer'].type === 'checkbox'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'">
                            <div
                                v-for="(answer, idx) in content['answer'].options"
                                :key="idx"
                            >
                                <div v-if="idx !== 'empty' && editMode === true">
                                    <input
                                        v-if="answer.value"
                                        :type="content['answer'].type"
                                        :value="answer.id"
                                        v-model="form['questions'][0][contentIndex]['answer']['options'][idx]['value']"
                                        checked
                                    />
                                    <input
                                        v-else
                                        :type="content['answer'].type"
                                        :value="answer.id"
                                        v-model="form['questions'][0][contentIndex]['answer']['options'][idx]['value']"
                                    />
                                    <span
                                        class="ms-2"
                                        :style="'color:' + answer.color + ';'"
                                    >
                                   {{ answer.name }}
                               </span>
                                    <textarea-plus
                                        v-if="answer.note"
                                        placeholder="Typ hier de toelichting"
                                        :value="form['questions'][0][contentIndex]['answer']['options'][idx]['noteText']"
                                        @onChange="form['questions'][0][contentIndex]['answer']['options'][idx]['noteText'] = $event"
                                    ></textarea-plus>
                                </div>
                                <div v-else>
                                    <div v-if="answer.value">
                                        {{ answer.name }} <br>
                                        <div v-if="answer.noteText">
                                            Toelichting: {{ answer.noteText }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-else-if="content['answer'].type === 'text'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'"
                        >
                            <input
                                v-if="editMode === true"
                                type="text"
                                class="form-control"
                                :placeholder="content.text"
                                v-model="form['questions'][0][contentIndex]['answer']['value']"
                            />
                            <div v-else>
                            <span v-if="content['answer'].value">
                                {{ content['answer'].value }}
                            </span>
                                <span v-else>
                                -
                            </span>
                            </div>
                        </div>
                        <div
                            v-else-if="content['answer'].type === 'textarea'"
                            :style="'margin-left:' + calculateMargin(content.marginLeft) + 'px;'"
                        >
                        <textarea-plus
                            v-if="editMode === true"
                            :placeholder="content.text"
                            :value="form['questions'][0][contentIndex]['answer']['value']"
                            @onChange="form['questions'][0][contentIndex]['answer']['value'] = $event"
                        ></textarea-plus>
                            <div v-else>
                            <span v-if="content['answer'].value">
                                {{ content['answer'].value }}
                            </span>
                                <span v-else>
                                -
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <br>
            <div
                v-if="editMode === true"
                class="d-grid gap-2"
            >
                <button v-if="isAuthorized('personal-data', 'form', 'edit')" v-on:click="saveForm(0)" class="btn btn-info">
                    Opslaan
                </button>
                <button v-if="isAuthorized('personal-data', 'form', 'edit')" v-on:click="saveForm(1)" class="btn btn-info">
                    Opslaan en definitief maken
                </button>
                <button v-on:click="cancelForm()" class="btn btn-danger">
                    Annuleren
                </button>
            </div>
            <div v-else>
                <button
                    v-on:click="form = null"
                    class="btn btn-block btn-secondary"
                >
                    Terug naar overzicht
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from "../../components/Icon.vue";
import TextareaPlus from '@/components/Textarea-Plus'

export default {
    name: 'children-intake-form',
    components: {
        Icon,
        TextareaPlus
    },
    computed: {
        deviceToken() {
            return this.$store.getters.deviceToken
        },
        session() {
            return this.$store.getters.session
        },
    },
    created() {
        window.novict = {
            device: {
                device_token: this.deviceToken
            },
            session: {
                session_token: this.session.session_token
            }
        }
        this.loadFilledInQuestionnairesByIdChild(this.selectedChild.id)
        this.loadQuestionnaireTemplates()
    },
    methods: {
        getUtilization() {
            let utilization = 3
            if (this.isGastouderapp()) {
                utilization = 4
            }
            return utilization
        },
        viewForm(filledInForm) {
            this.editMode = false
            this.form = JSON.parse(filledInForm.jsonContent)
            this.id = filledInForm.id
            this.idGeneralForm = filledInForm.idGeneralForm
            this.idQuestionnaireTemplate = filledInForm.idQuestionnaireTemplate
        },
        editForm(template, edit = false) {
            this.editMode = true
            this.form = JSON.parse(template.jsonContent)
            this.id = edit ? template.id : null
            this.idGeneralForm = template.idGeneralForm
            this.idQuestionnaireTemplate = template.idQuestionnaireTemplate
        },
        saveForm(formStatus) {
            this.status = 'open'
            if (formStatus === 1) {
                this.status = 'done'
            }
            this.$request.post(process.env.VUE_APP_API_V3_URL +  '/saveQuestionnaire', {
                ...this.$request.getDeprecatedBodyAuthentication(),
                id: this.id,
                idGeneralForm: this.idGeneralForm,
                idQuestionnaireTemplate: this.idQuestionnaireTemplate,
                idChild: this.selectedChild.id,
                status: formStatus,
                json: JSON.stringify(this.form),
                idEstablishment: this.$store.getters.selectedEstablishment.id
            })
                .then(data => {
                    if (data) {
                        if (data.saved === true) {
                            this.loadFilledInQuestionnairesByIdChild(this.selectedChild.id)
                            this.form = null
                            return true
                        }
                    }
                    alert('Fout bij het opslaan, probeer opnieuw')
                })
        },
        cancelForm() {
            if (confirm('Weet je zeker dat je het formulier NIET wilt opslaan?')) {
                this.form = null
            }
        },
        loadFilledInQuestionnairesByIdChild(id_child) {
            this.isLoading = true
            this.filledInForms = {
                open: [],
                done: []
            }

            this.$request.post(process.env.VUE_APP_API_V3_URL + '/filledInGeneralForms', {
                ...this.$request.getDeprecatedBodyAuthentication(),
                idChild: id_child,
                utilization: this.getUtilization()
            })
                .then(data => {
                    this.isLoading = false
                    if(Array.isArray(data)) {
                        data.forEach((element) => {
                            if (element.status === 0) {
                                this.filledInForms.open.push(element)
                            } else if (element.status === 1) {
                                this.filledInForms.done.push(element)
                            }
                        });
                        if (
                            this.filledInForms.open.length > 0
                            && this.status === 'new'
                        ) {
                            this.status = 'open'
                        } else if (
                            this.filledInForms.done.length > 0
                            && this.status === 'new'
                        ) {
                            this.status = 'done'
                        }
                    }
                })
        },
        loadQuestionnaireTemplates() {
            this.isLoading = true
            this.$request.post(process.env.VUE_APP_API_V3_URL + `/getQuestionnaireGeneralForms`, {
                ...this.$request.getDeprecatedBodyAuthentication(),
                utilization: this.getUtilization()
            })
                .then(generalForms => {
                    this.isLoading = false
                    this.formTemplates = generalForms
                })
        },
        shareForm(event, id) {
            this.$request.post(process.env.VUE_APP_API_V3_URL +  '/shareQuestionnaire', {
                ...this.$request.getDeprecatedBodyAuthentication(),
                id: id,
                share: event.target.checked,
                utilization: this.getUtilization()
            })
                .then(data => {
                    if (data) {
                        if (data.saved === true) {
                            this.loadFilledInQuestionnairesByIdChild(this.selectedChild.id)
                            return true
                        }
                    }
                    alert('Fout bij het opslaan, probeer opnieuw')
                })
        },
        downloadForm(id, title) {
            this.$request.get(process.env.VUE_APP_API_V3_URL +  '/downloadQuestionnaire/' + this.selectedChild.id + '/' + id, {
                responseType: 'blob'
            })
                .then(response => {
                    if (response) {
                        let filename = title + '.pdf'
                        this.downloadPDF(filename, response)
                    } else {
                        alert("Er is een fout opgetreden tijdens het downloaden")
                    }
                })
        },
        getJsonFromForm() {
            return JSON.stringify(this.form)
        },
        calculateMargin(margin) {
            return parseInt(margin) + 10;
        }
    },
    data() {
        return {
            isLoading: false,
            status: this.isAuthorized('personal-data', 'form', 'edit') ? 'new' : 'done',
            formTemplates: null,
            filledInForms: {
                open: [],
                done: [],
            },
            editMode: true,
            form: null,
            id: null,
            idQuestionnaireTemplate: null,
            idGeneralForm: null
        }
    }
}
</script>

<style scoped>
select {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    background-color: #ffffff;
    box-sizing: border-box;
    padding-left: 16px;
    padding-right: 16px;
    height: 30px;
    border-radius: 4px;
    border: 1px solid #c8c8c8 !important;
}

.toolbar-bg {
    background-color: rgba(0,0,0,.025);
    border-top: 1px solid rgba(0,0,0,.1);
    border-bottom: 1px solid rgba(0,0,0,.1);
}
.btn-group-toggle label {
    margin: 0;
}
.btn-group-toggle .btn-outline-secondary {
    background-color: #fff;
    border-color: rgba(0,0,0,.2);
    color: rgba(0,0,0,.5);

    &:hover {
        background-color: rgba(0,0,0,.01);
    }
}
.btn-group-toggle .btn-check:checked + .btn {
    color: hsl(206, 90%, 20%);
    background-color: hsl(206, 68%, 90%);
    border-color: hsl(206, 86%, 73%);
    box-shadow: none;
}
</style>
